<mat-card>

  <mat-card-header fxLayout="row wrap" fxLayoutAlign="space-between center" style="padding-bottom: 0px">

    <mat-card-title>{{ (configuration?.IsQuotation ? 'RowQuotation' : 'DetailWorkOrder') | translate }}</mat-card-title>

  </mat-card-header>

  <mat-card-content class="movement-manager-rows-table" style="padding-top: 0px">

    <div style="display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 5px">

      <div></div>

      <div>

        <div style="display: inline-block; margin-right: 5px"
             *ngIf="isCreateButtonVisible"
             [matTooltip]="createButtonTooltip"
             [matTooltipDisabled]="!createButton.disabled"
             matTooltipPosition="above">
          <ct-button [configuration]="createButton"></ct-button>
        </div>

        <button mat-raised-button style="margin-right: 0px" (click)="toggleFilters(table)">
          <mat-icon [color]="filterPanelEnabled ? 'primary' : 'accent'"> {{ filterPanelEnabled ? 'filter_alt_off' :
            'filter_alt' }}
          </mat-icon>
        </button>

      </div>

    </div>

    <p-table #table dataKey="Oid" [value]="items" [selection]="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable ? selectedItems : []"
      (selectionChange)="onSelectionChange($event)" [columns]="cols" [paginator]="true" [resizableColumns]="true"
      [rows]="10" [showCurrentPageReport]="true" [expandedRowKeys]="" autoLayout="true"
      [currentPageReportTemplate]="items.length ? 'totale {totalRecords}' : ''">

      <!-- HEADER: Intestazione colonne con sort e filtri -->
      <ng-template pTemplate="header" let-columns>

        <!-- Prima riga: Intestazioni colonne -->
        <tr>
          <!-- Colonna checkbox header - mostrata solo se multiCheckBoxTable è true -->
          <th style="width: 3rem" *ngIf="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable">
            <p-checkbox [checked]="isAllSelectableChecked()" (onChange)="toggleAllSelectable($event)"
              [disabled]="!hasSelectableItems()" binary="true">
            </p-checkbox>
          </th>

          <th style="min-width: 80px;"
              *ngFor="let col of columns"
              pResizableColumn
              [pSortableColumn]="col.field"
              [ngClass]="{'text-right-header': col.field === 'Quantity' || col.field === 'Amount' || col.field === 'Discount' || col.field === 'VAT' || col.field === 'Total'}">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field" />
          </th>

          <th style="width: 80px"></th>

        </tr>

        <!-- Seconda riga: Filtri (nascosta di default) -->
        <tr [hidden]="!filterPanelEnabled">
          <th *ngIf="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable"></th>

          <th style="padding: 0.5rem;" *ngIf="isCol('Code')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="Code"
              placeholder="Cerca per codice" />
          </th>

          <th style="padding: 0.5rem;" *ngIf="isCol('Description')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="Description"
              placeholder="Cerca per descrizione" />
          </th>

          <th style="padding: 0.5rem;" *ngIf="isCol('Type')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="Type"
              placeholder="Cerca per tipo" />
          </th>

          <th style="padding: 0.5rem;" *ngIf="isCol('Quantity')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="Quantity"
              placeholder="Cerca per quantità" />
          </th>

          <th style="padding: 0.5rem;" *ngIf="isCol('Amount')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="Amount"
              placeholder="Cerca per prezzo" />
          </th>

          <!-- Filtro colonna Sconto -->
          <th style="padding: 0.5rem;" *ngIf="isCol('Discount')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="Discount"
              placeholder="Cerca per sconto" />
          </th>

          <th style="padding: 0.5rem;" *ngIf="isCol('VAT')">
            <p-columnFilter [showMenu]="false" [showClearButton]="false" type="text" field="VAT"
              placeholder="Cerca per IVA" />
          </th>

          <!-- Colonna Totale non ha filtro -->
          <th style="padding: 0.5rem;" *ngIf="isCol('Total')"></th>

          <th></th>

        </tr>

      </ng-template>

      <!-- BODY: Righe dati -->
      <ng-template pTemplate="body" let-item let-ri="rowIndex">

        <tr [pSelectableRow]="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable ? item : null"
          [pSelectableRowDisabled]="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable && isRowDisabled(item)"
          [ngClass]="{'disabled-row': this.colsWorkOrderRowsConfiguration.multiCheckBoxTable && isRowDisabled(item)}">

          <!-- Colonna checkbox - mostrata solo se multiCheckBoxTable è true -->
          <td *ngIf="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable">
            <p-tableCheckbox [value]="item" [disabled]="isRowDisabled(item)"></p-tableCheckbox>
          </td>

          <!-- Colonna Codice -->
          <td *ngIf="isCol('Code')">
            {{ item.Code }}
          </td>

          <!-- Colonna Descrizione: troncata a 30 caratteri, tutta cliccabile per espandere -->
          <td *ngIf="isCol('Description')" class="description-cell">
            <!-- Se la descrizione è troncata, tutta la cella è cliccabile -->
            <div class="description-wrapper"
                 [class.clickable]="isDescriptionTruncated(item.Description)"
                 (click)="isDescriptionTruncated(item.Description) ? openDescriptionDialog(item) : null">
              <span class="post-desc">{{ truncateDescription(item.Description) }}</span>
              <!-- Icona "espandi" solo se la descrizione è troncata -->
              <mat-icon *ngIf="isDescriptionTruncated(item.Description)" class="expand-icon">open_in_full</mat-icon>
            </div>
          </td>

          <!-- Colonna Tipo -->
          <td *ngIf="isCol('Type')">
            {{ item.Type }}
          </td>

          <!-- Colonna Quantità: allineata a destra -->
          <td *ngIf="isCol('Quantity')" class="text-right">
            {{ item.Quantity | formatNumber }}
          </td>

          <!-- Colonna Prezzo Articolo: allineata a destra -->
          <td *ngIf="isCol('Amount')" class="text-right">
            {{ (item.Amount ?? 0) | formatPrice }}
          </td>

          <!-- Colonna Sconto: allineata a destra -->
          <td *ngIf="isCol('Discount')" class="text-right">
            {{ item.Discount ? (item.Discount + '%') : '-' }}
          </td>

          <!-- Colonna IVA: allineata a destra -->
          <td *ngIf="isCol('VAT')" class="text-right">
            {{ item.VAT ? (item.VAT + '%') : '-' }}
          </td>

          <!-- Colonna Totale: gestione sconto -->
          <td *ngIf="isCol('Total')" class="text-right total-column">
            <!-- Caso CON sconto: mostra prezzo originale barrato e prezzo scontato evidenziato -->
            <ng-container *ngIf="hasDiscount(item)">
              <span class="original-price">{{ calculateRowTotal(item) | formatPrice }}</span>
              <span class="discounted-price">
                {{ calculateDiscountedTotal(item) | formatPrice }} <small>(-{{ item.Discount }}%)</small>
              </span>
            </ng-container>

            <!-- Caso SENZA sconto: mostra solo il totale normale -->
            <ng-container *ngIf="!hasDiscount(item)">
              <span class="normal-price">{{ calculateRowTotal(item) | formatPrice }}</span>
            </ng-container>
          </td>

          <!-- Colonna Azioni (edit/clone/delete) -->
          <td>
            <div style="display: flex">
              <!-- Bottone Edit: sempre visibile -->
              <button pButton pRipple type="button" (click)="onRowEdit(ri, item)" class="p-button-text primary"
                [matTooltip]="'Modifica' | translate">
                <mat-icon>edit</mat-icon>
              </button>

              <!-- Bottone Clone: visibile solo se abilitato in configurazione -->
              <button pButton pRipple type="button" 
                *ngIf="colsWorkOrderRowsConfiguration.cloneRowEnabled"
                (click)="onRowClone(item)" 
                class="p-button-text accent"
                [matTooltip]="'Clona riga' | translate">
                <mat-icon>content_copy</mat-icon>
              </button>

              <!-- Bottone Delete: visibile solo se riga non chiusa -->
              <button pButton pRipple type="button" *ngIf="item.State !== WorkOrderRowState.Closed"
                (click)="onRowDelete(ri, item)" class="p-button-text warn"
                [matTooltip]="'Elimina' | translate">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>

        </tr>

      </ng-template>

      <!-- FOOTER: Riga totale complessivo (condizionale) -->
      <ng-template pTemplate="footer" let-columns>
        <!-- Mostra riga totale solo se ci sono righe E showTotalRow è true -->
        <tr *ngIf="items.length > 0 && colsWorkOrderRowsConfiguration.showTotalRow" class="total-row">
          <!-- Colspan: checkbox (se presente) + tutte le colonne tranne Total -->
          <td [attr.colspan]="columns.length - 1 + (this.colsWorkOrderRowsConfiguration.multiCheckBoxTable ? 1 : 0)"
              class="total-label">
            <strong>{{ 'Totale' | translate }}</strong>
          </td>
          <!-- Colonna Totale complessivo (allineata con colonna Total delle righe) -->
          <td class="text-right total-amount">
            <strong>{{ calculateGrandTotal() | formatPrice }}</strong>
          </td>
          <!-- Colonna azioni vuota (allineata con colonna azioni delle righe) -->
          <td></td>
        </tr>
      </ng-template>

      <!-- EMPTY MESSAGE: Messaggio quando non ci sono dati -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="this.colsWorkOrderRowsConfiguration.multiCheckBoxTable ? columns.length + 2 : columns.length + 1"
            class="empty-message-cell">
            <div class="empty-message-container">
              <mat-icon class="empty-icon">inbox</mat-icon>
              <p class="empty-text">{{ 'CT_MESSAGES.no_available_data' | translate }}</p>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </mat-card-content>

</mat-card>
